import { render, staticRenderFns } from "./churumbela.vue?vue&type=template&id=0cda6190&scoped=true"
import script from "./churumbela.vue?vue&type=script&lang=js"
export * from "./churumbela.vue?vue&type=script&lang=js"
import style0 from "./churumbela.vue?vue&type=style&index=0&id=0cda6190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda6190",
  null
  
)

export default component.exports